// extracted by mini-css-extract-plugin
export var buttonWrapper = "RegularHeaderBlock-module--buttonWrapper--b41c6";
export var image = "RegularHeaderBlock-module--image--6f429";
export var imageWrapper = "RegularHeaderBlock-module--imageWrapper--2c3fd";
export var secondLine = "RegularHeaderBlock-module--secondLine--16899";
export var textWrapper = "RegularHeaderBlock-module--textWrapper--33c57";
export var titleWrapper = "RegularHeaderBlock-module--titleWrapper--a3c78";
export var wrapper = "RegularHeaderBlock-module--wrapper--2de8c";